import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SymbolAction } from './symbol.action';
import { symbolInitialState } from './symbol.constant';
import { ISymbolStore } from './symbol.interface';

export const symbolReducer = reducerWithInitialState(symbolInitialState)
  .case(SymbolAction.load.started, (state, params) => {
    const { data } = state;
    const symbolData = data[params.symbolId];

    return {
      ...state,
      data: {
        ...data,
        [params.symbolId]: {
          ...symbolData,
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(SymbolAction.load.done, (state, { params, result }): ISymbolStore => {
    return {
      ...state,
      data: {
        ...state.data,
        [params.symbolId]: {
          ...result,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(SymbolAction.load.failed, (state, { params }) => {
    const { data } = state;
    const symbolData = data[params.symbolId];

    return {
      ...state,
      data: {
        ...data,
        [params.symbolId]: {
          ...symbolData,
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .cases([SymbolAction.loadList.started, SymbolAction.processing.started], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(SymbolAction.loadBaseSymbols.started, (state) => {
    return {
      ...state,
      baseSymbolsData: {
        ...state.baseSymbolsData,
        networkStatus: NetworkStatus.Started,
      },
    };
  })
  .case(SymbolAction.loadList.done, (state, { result }): ISymbolStore => {
    const { totalCount, filteredCount } = result;

    return {
      ...state,
      totalCount,
      filteredCount,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolAction.loadBaseSymbols.done, (state, { result }): ISymbolStore => {
    return {
      ...state,
      baseSymbolsData: {
        list: result,
        networkStatus: NetworkStatus.Done,
      },
    };
  })
  .case(SymbolAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(SymbolAction.loadBaseSymbols.failed, (state) => {
    return {
      ...state,
      baseSymbolsData: {
        ...state.baseSymbolsData,
        networkStatus: NetworkStatus.Failed,
      },
    };
  })
  .cases([SymbolAction.processing.done, SymbolAction.processing.failed], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolAction.update.done, (state, { params }): ISymbolStore => {
    return {
      ...state,
      data: {
        ...state.data,
        [params.symbolId]: {
          ...state.data[params.symbolId],
          ...params,
        },
      },
    };
  })
  .case(SymbolAction.destroy, () => ({
    ...symbolInitialState,
  }));
